import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section
      aria-labelledby="hero-heading"
      className="relative isolate flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-b from-sky-50 via-indigo-50 to-white px-6 pt-32 pb-16 text-center lg:px-8"
    >
      {/* Background gradient shapes */}
      <div
        aria-hidden="true"
        role="presentation"
        className="pointer-events-none absolute inset-x-0 -top-64 -z-10 transform-gpu overflow-hidden blur-3xl"
      >
        <div
          className="relative left-1/2 aspect-[1108/632] w-[72rem] -translate-x-1/2 
          bg-[radial-gradient(circle_at_top,_rgba(79,70,229,0.35),_transparent_60%),radial-gradient(circle_at_bottom,_rgba(56,189,248,0.35),_transparent_55%)] opacity-80"
        />
      </div>

      <div
        aria-hidden="true"
        role="presentation"
        className="pointer-events-none absolute inset-y-0 left-1/2 -z-10 
        w-[40rem] -translate-x-1/2 bg-gradient-to-b from-indigo-200/40 
        via-sky-100/40 to-transparent blur-3xl"
      />

      {/* Hero Content */}
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-8">

        {/* Eyebrow / tagline */}
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-700/80">
          Nordens ledande partner inom logistik och transporter.
        </p>

        {/* MAIN H1 (super important for SEO) */}
        <h1
          id="hero-heading"
          className="text-balance text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl"
        >
          Effektiva och pålitliga transporter för hela Norden.
        </h1>

        {/* Subheading */}
        <p className="mt-3 text-pretty text-base text-slate-600 sm:text-lg">
          Nordic Route erbjuder godstransport, expressleveranser och specialtransporter, 
          med fokus på precision, punktlighet och trygghet.
        </p>

        {/* CTA Button */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            aria-label="Kontakta Nordic Route för att begära offert eller starta ett samarbete"
            className="inline-flex items-center justify-center rounded-full bg-indigo-600 
            px-8 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-600/30 
            transition hover:bg-indigo-700 hover:shadow-indigo-700/40 
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 
            focus-visible:ring-offset-2 focus-visible:ring-offset-indigo-50"
          >
            Kontakta oss
          </Link>
        </div>

        {/* Trust indicators */}
        <div className="mt-8 flex flex-col items-center gap-2 text-xs text-slate-500 sm:flex-row sm:gap-4">
          <span
            role="note"
            className="inline-flex items-center gap-2 rounded-full bg-white/70 
            px-4 py-1 shadow-sm ring-1 ring-slate-200/80 backdrop-blur"
          >
            <span aria-hidden="true" className="size-1.5 rounded-full bg-emerald-500" />
            Leveranser i hela Norden, dygnet runt.
          </span>

        </div>

      </div>
    </section>
  );
};

export default HeroSection;
